import { ref } from "@vue/composition-api";

const isOpen = ref(false);

export { isOpen };
